export default __webpack_public_path__ + "static/media/owl2.e63d8084.png";